'use strict';
UserDialogController.$inject = ['$scope', '$mdDialog'];
angularApp.dcyApplication.register.controller('userDialogCtrl', ($scope, $mdDialog, userButtonsInfo, userInfo, mainTopCtrl) => new UserDialogController($scope, $mdDialog, userButtonsInfo, userInfo, mainTopCtrl));
